import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "zxLiveCourse/";

// 直播课程 - 列表查询-分页
export const liveMyPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myPage", {
           data: _params,
           method: "GET",
         });
       };
// 直播课程 - 获取最新的一条通知信息
export const getPullStreamUrl = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getPullStreamUrl", {
           data: _params,
           method: "GET",
         });
       };
// 直播课程 - 获取回放地址
export const getPlaybackUrl = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getPlaybackUrl", {
           data: _params,
           method: "GET",
         });
       };
// 直播课程 - 获取回放地址列表
export const getPlaybackList = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getPlaybackList", {
           data: _params,
           method: "GET",
         });
       };
// 直播课程 - 获取消息鉴权信息
export const getMessageAuthInfo = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getMessageAuthInfo", {
           data: _params,
           method: "GET",
         });
       };

// 直播课程 - 获取详情
export const liveView = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "view", {
           data: _params,
           method: "GET"
         });
       };


// WEBPACK FOOTER //
// ./src/fetch/api/liveCourse.js